import React, { useEffect, useState } from "react";
import "../css/dashboard.css";
import { getPgDetailsByOwner } from "./apiService";
import { useAuth } from "./auth";
import { Outlet, useNavigate } from "react-router-dom";

const MyDashboard = () => {
  const [pgdetails, setPgdetails] = useState([]);
  const { userid, pgId, user } = useAuth();
  const navigate = useNavigate();

  useEffect(() => {
    getPgDetailsByOwner(userid).then((res) => {
      setPgdetails(res);
    });
  }, [userid]);

  const handlePg = (pg) => {
    pgId(pg.id);
    navigate("/MyDashboard/PaymentDetails");
  };
  return (
    <div>
      <div className="welcome-msg">Welcome @ {user}</div>
      <div className="header container-box">MyDashboard</div>
      <div className="container-cls">
        <div className="subcontainer-cls">
          <div className="tabs-cls">
            {pgdetails.map((pg) => {
              if (pg.owner === userid) {
                return (
                  <div key={pg.id}>
                    <button className="btn-cls" onClick={() => handlePg(pg)}>
                      {pg.pgname}
                    </button>
                  </div>
                );
              }
              return null;
            })}
          </div>
          <Outlet />
        </div>
      </div>
    </div>
  );
};

export default MyDashboard;
